


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const getInvociesCounterReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.GET_ALL_INVOICES_COUNTER:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.GET_ALL_INVOICES_COUNTER_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.GET_ALL_INVOICES_COUNTER_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
